import { Box, Card, Skeleton, Stack, Text } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { useTranslations } from 'use-intl';

import { useGetSubscriptionQuery } from '@blockpulse3/graphql/hooks';
import { formatNumberCurrency } from '@blockpulse3/helpers';
import { ErrorQueryCard } from '@blockpulse3/ui/commons';

export function SubscriptionFundraisingInformations(): JSX.Element {
  const i18nSubscribeProgressionBar = useTranslations(
    'SubscriptionInformations.SubscriptionFundraisingInformations',
  );

  const { subscriptionId = '' } = useParams();

  const { data, loading, error } = useGetSubscriptionQuery({
    variables: { subscriptionId },
  });

  if (loading) {
    return (
      <Skeleton>
        <Card h="80px" />
      </Skeleton>
    );
  }

  if (error) {
    return <ErrorQueryCard h="80px" />;
  }

  if (!data) {
    return <ErrorQueryCard h="80px" />;
  }

  const { subscription } = data;

  return (
    <Stack direction={{ base: 'column', md: 'row' }} spacing={{ base: '4', md: '8' }}>
      <Box bg="gray.50" color="white" p="4" w="full">
        <Text color="gray.500" fontWeight="500">
          {i18nSubscribeProgressionBar('FundraisingHardCap')}
        </Text>
        <Text color="gray.800" fontSize="lg" fontWeight="600">
          {formatNumberCurrency(subscription?.fundraising?.hardCap || 0)}
        </Text>
      </Box>
      <Box bg="gray.50" color="white" p="4" w="full">
        <Text color="gray.500" fontWeight="500">
          {i18nSubscribeProgressionBar('FundraisingPricePerShare')}
        </Text>
        <Text color="gray.800" fontSize="lg" fontWeight="600">
          {formatNumberCurrency(subscription?.fundraising?.pricePerShare || 0)}
        </Text>
      </Box>
    </Stack>
  );
}
